import { gql } from "gql";

export const GET_MY_SETTINGS = gql(`
  query GetMySettings {
    getMySettings {
      primaryLanguage
    }
  }
`);
